
import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/integrations/supabase/types'

const supabaseUrl = "https://wvywevmiccitipsadynu.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind2eXdldm1pY2NpdGlwc2FkeW51Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg3NDg0NTAsImV4cCI6MjA1NDMyNDQ1MH0.DDlpWXHHCOzKV7ugrnJlPY5kMlQbVJhZw6q9ye_WLFI"

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be defined')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "pkce"
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
})

// Track auth state changes
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth state changed:', event, session ? 'User authenticated' : 'No user')
})

// Add a simple health check method
export const checkSupabaseConnection = async () => {
  try {
    console.log('Checking Supabase connection...');
    const { error } = await supabase.from('profiles').select('count').limit(1);
    if (error) {
      console.error('Supabase connection failed:', error);
      return false;
    }
    console.log('Supabase connection successful');
    return true;
  } catch (e) {
    console.error('Supabase connection exception:', e);
    return false;
  }
}
